import { render, staticRenderFns } from "./NotificationsSettingsFormPromotions.vue?vue&type=template&id=763774d6"
import script from "./NotificationsSettingsFormPromotions.vue?vue&type=script&lang=js"
export * from "./NotificationsSettingsFormPromotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports